"use client";

import { cn } from "@/lib/utils";
import { ReactNode, useContext } from "react";
import { SuperLink as Link } from "@/components/common/super-link";
import { XIcon } from "lucide-react";
import { clientGet } from "@/service/client-api/client-api";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { useRouter } from "@bprogress/next";
import { toast } from "sonner";

export const HistoryAndFavouriteListItem = ({
  item,
  createItemPath,
  isFavourite,
}: {
  item: HistoryAndSectionItem;
  createItemPath: (item: any) => string;
  isFavourite: boolean;
}) => {
  const iconStyles = cn(`flex h-6 w-6 items-center justify-center rounded-md`);
  const { logView } = useContext(ResourceContext);
  const router = useRouter();
  const IconWrapper = ({
    asHtml,
    asNode,
  }: {
    asHtml?: string;
    asNode?: ReactNode;
  }) => {
    return asHtml ? (
      <div
        className={iconStyles}
        dangerouslySetInnerHTML={{ __html: asHtml }}
      />
    ) : (
      <div className={cn(iconStyles, "w-auto")}>{asNode}</div>
    );
  };

  return (
    <Link
      key={item.title}
      className={`relative flex max-w-[280px] items-center justify-between gap-2 truncate rounded-xl border bg-[#FAFAFA] px-3 py-2 text-sm font-medium text-zinc-900 transition-all hover:border-zinc-300 [&_svg]:w-6`}
      href={createItemPath(item)}
      onClick={() => {
        logEvent("history_favourite_item_click", logView, {
          resource_url: createItemPath(item),
          title: item.title,
          list_type: isFavourite ? "favourite" : "history",
        });
      }}
    >
      <IconWrapper asNode={item.icon} asHtml={item.category?.svgContent} />
      <div
        className={cn(
          "truncate",
          isFavourite ? "w-[calc(100%-24px)]" : "w-full",
        )}
      >
        {item.title}
      </div>
      {isFavourite && (
        <div
          onClick={async (e) => {
            e.stopPropagation();
            e.preventDefault();

            await clientGet("favourite", {
              ...item.favourite,
              action: "remove",
            });

            logEvent("toggle_favourite_resource", logView, {
              ...item.favourite,
              resource_action: "remove",
            });

            toast.info("Usunięto z zapisanych");

            router.refresh();
          }}
          className={
            "text-muted-foreground flex h-5 w-5 cursor-pointer items-center justify-center rounded-md bg-[#FAFAFA] transition-all hover:bg-[#EAEAEA]"
          }
        >
          <XIcon size={16} />{" "}
        </div>
      )}
    </Link>
  );
};
